export const SAVE_TENANT = 'SAVE_TENANT'
